import React from 'react'
import { UncontrolledTooltip } from 'reactstrap';
import { Popover as AntdPopover, Button, Checkbox, Select, Switch } from "antd";
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function GetTaskFilterSetting({taskFilterSetting, setTaskFilterSetting,
    dealTaskFilterSettings, setDealTaskFilterSetting
}) {
  return ( <>
        <UncontrolledTooltip placement="top" target="filter-setting">
          Group Setting
        </UncontrolledTooltip>
        <AntdPopover
          placement="bottom"
          trigger="click"
          // isOpen={employeeNotePopup}
          overlayClassName="add-columns-tasks"
          content={
            <div>

              {/* <hr className="hrcls"></hr> */}
              <div className="row task-filter-hovr">
                <div className="col-sm-9">
                  <a onClick={() => { }}>Task Location</a>
                </div>
                <div className="col-sm-3">
                  <Switch
                    onChange={(checked, event) => {
                      const obj = { ...taskFilterSetting };
                      obj["TaskLocation"] = checked;
                      setTaskFilterSetting(obj);
                    }}
                    size="small"
                    checked={taskFilterSetting.TaskLocation}
                  />
                </div>
              </div>

              <hr className="hrcls"></hr>
              <div className="row task-filter-hovr">
                <div className="col-sm-9">
                  <a onClick={() => { }}>Subtask Parent Names</a>
                </div>
                <div className="col-sm-3">
                  <Switch
                    onChange={(checked, event) => {
                      const obj = { ...taskFilterSetting };
                      if (checked) {
                        obj["SubtaskParntNames"] = checked;
                        obj["ExpandTasks"] = true;
                        obj["ExpandGroups"] = true;
                        obj["ExpandDeals"] = true;
                      } else {
                        obj["SubtaskParntNames"] = checked;
                      }
                      setTaskFilterSetting(obj);
                    }}
                    size="small"
                    checked={taskFilterSetting.SubtaskParntNames}
                  />
                </div>
              </div>
              <hr className="hrcls"></hr>
              <div className="row task-filter-hovr">
                <div className="col-sm-9">
                  <a onClick={() => { }}>Expand All Deals</a>
                </div>
                <div className="col-sm-3">
                  <Switch
                    onChange={(checked, event) => {
                      const obj = { ...taskFilterSetting };
                      if (checked) {
                        obj["ExpandDeals"] = checked;
                      } else {
                        obj["ExpandDeals"] = checked;
                        obj["ExpandTasks"] = false;
                        obj["ExpandGroups"] = false;
                      }
                      setTaskFilterSetting(obj);
                    }}
                    size="small"
                    checked={taskFilterSetting.ExpandDeals}
                  />
                </div>
              </div>

              <hr className="hrcls"></hr>
              <div className="row task-filter-hovr">
                <div className="col-sm-9">
                  <a>Expand All Groups</a>
                </div>
                <div className="col-sm-3">
                  <Switch
                    onChange={(checked, event) => {
                      const obj = { ...taskFilterSetting };
                      if (checked) {
                        obj["ExpandGroups"] = checked;
                        obj["ExpandDeals"] = true;
                      } else {
                        obj["ExpandGroups"] = checked;
                        obj["ExpandTasks"] = false;
                      }
                      setTaskFilterSetting(obj);
                    }}
                    size="small"
                    checked={taskFilterSetting.ExpandGroups}
                  />
                </div>
              </div>

              <hr className="hrcls"></hr>
              <div className="row task-filter-hovr">
                <div className="col-sm-9">
                  <a onClick={() => { }}>Expand All Tasks</a>
                </div>
                <div className="col-sm-3">
                  <Switch
                    onChange={(checked, event) => {
                      const obj = { ...taskFilterSetting };
                      if (checked) {
                        obj["ExpandTasks"] = checked;
                        obj["ExpandGroups"] = true;
                        obj["ExpandDeals"] = true;
                      } else {
                        obj["ExpandTasks"] = checked;
                      }
                      setTaskFilterSetting(obj);
                    }}     
                    size="small"
                    checked={taskFilterSetting.ExpandTasks}
                  />
                </div>
              </div>
            </div>
          }
        >
          <span className="ml-3 mr-3">
            <FontAwesomeIcon icon={faEllipsisV} id="filter-setting" />
          </span>
        </AntdPopover>
      </>)
}
